import React, { Component } from "react";
import Filter from "../Filter/Filter";
import "./Categories.css";
import CategoryRow from "./CategoryRow/CategoryRow";
import Toast from "../Toast/Toast";
import Connection from "../../classes/Connection";

class Categories extends Component {
    constructor(props) {
        super(props);
        this.Connection = new Connection();

        this.delete = this.delete.bind(this);
        this.onDrag = this.onDrag.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);
        this.save_new_arrange = this.save_new_arrange.bind(this);

        this.save_category = this.save_category.bind(this);
        this.edit = this.edit.bind(this);
        this.imageInputRef = React.createRef();
    }
    state = {
        newCategory: { name: null, image: null },
        editingCatName: null,
        rearranged: false,
        dragged: null,
    };

    componentDidMount() {
        this.props.connection
            .getAllCategories()
            .then((res) => {
                this.setState({ categories: res.data });
            })
            .catch((err) => {
                console.log(err);
            });
    }

    delete(cat) {
        let { categories } = this.state;
        let { toast, connection } = this.props;
        categories.splice(
            categories.findIndex((c) => {
                return c.name === cat.name;
            }),
            1
        );
        this.setState({ categories });
        connection
            .deleteCategory(cat.name)
            .then((res) => {
                this.setState({ categories });
                toast("حذف دسته بندی", "دسته بندی حذف شد : ", " confirm");
            })
            .catch((err) => {
                categories = [cat, ...categories];

                this.setState({ categories });
                toast("حذف دسته بندی", "دسته بندی حذف نشد : " + err, " danger");
            });
    }

    uploadFiles(files) {
        return new Promise((resolve, reject) => {
            if (files.length === 0) resolve([]);
            this.props.connection
                .upload(files, () => {})
                .then((results) => {
                    this.props.toast(
                        "آپلود",
                        "تمام فایل ها با موفقیت آپلود شدند",
                        " confirm"
                    );
                    resolve(results);
                })
                .catch((err) => {
                    this.props.toast(
                        "خطا در آپلود فایل ها",
                        `آپلود با خطا مواجه شد لطفا مجددا تلاش کنید\n
                                            خطا:\n
                                            ${err.code}\n
                                            ${err.name}\n
                                            ${err.response.data}\n
                                            `,
                        " danger"
                    );
                    reject(err);
                });
        });
    }

    edit(name) {
        this.setState({
            editingCatName: name,
            newCategory: this.state.categories.find((c) => {
                return c.name === name;
            }),
        });
    }

    save_category() {
        let { toast, connection } = this.props;
        let { newCategory, editingCatName } = this.state;
        let { name, image } = newCategory;
        if (!name || name.length < 1) {
            toast(
                "خطا در نام دسته بندی",
                "نام دسته بندی نمیتواند خالی باشد.",
                " warning"
            );
            return;
        }
        if (!image) {
            toast(
                "خطا در تصویر دسته بندی",
                "یک تصویر برای دسته بندی خود انتخاب کنید",
                " warning"
            );
            return;
        }

        const save = () => {
            connection
                .save_category(newCategory)
                .then((res) => {
                    this.setState({
                        newCategory: { name: null, image: null },
                        editingCatName: null,
                    });
                    this.componentDidMount();
                    toast(
                        (editingCatName ? "ویرایش" : "افزودن") + " دسته بندی",
                        " دسته بندی با موفقیت " +
                            (editingCatName ? "ویرایش" : "اضافه") +
                            " شد.",
                        " confirm"
                    );
                })
                .catch((err) => {
                    toast(
                        (editingCatName ? "ویرایش" : "افزودن") + " دسته بندی",
                        " خطادر " +
                            (editingCatName ? "ویرایش" : "افزودن") +
                            " : " +
                            err.response.data,
                        " danger"
                    );
                });
        };

        image.file
            ? this.uploadFiles([image.file])
                  .then((urls) => {
                      newCategory.image = urls[0].url;
                      save();
                  })
                  .catch((err) => {})
            : save();
    }

    sendNewCatReq(category) {
        this.Connection.addNewCategory(category)
            .then((res) => {
                this.props.toast(
                    "دسته بندی",
                    "دسته بندی جدید با موفقیت اضافه شد",
                    " confirm"
                );
            })
            .catch((err) => {
                this.props.toast(
                    "دسته بندی",
                    "خطا در اضافه کردن دسته بندی جدید" + err,
                    " danger"
                );
            });
    }

    save_new_arrange() {
        let { categories } = this.state;
        let { toast, connection } = this.props;
        connection
            .save_new_categories_arrange(categories)
            .then((res) => {
                this.setState({ rearranged: false });
                toast(
                    "ذخیره چینش",
                    "چینش جدید دسته بندی ها ذخیره شد.",
                    " confirm"
                );
            })
            .catch((err) => {
                toast(
                    "ذخیره چینش",
                    "خطا در ذخیره چینش جدید : " + err.response.data,
                    " danger"
                );
            });
    }

    onDrag(category) {
        this.setState({ dragged: category });
    }

    onDrop(category) {
        let { categories, dragged } = this.state;
        const draggedIndex = categories.findIndex((c) => {
            return c.name === dragged.name;
        });
        categories.splice(draggedIndex, 1);

        const droppedIndex = categories.findIndex((c) => {
            return c.name === category.name;
        });

        droppedIndex >= draggedIndex
            ? (categories = [
                  ...categories.slice(0, droppedIndex + 1),
                  dragged,
                  ...categories.slice(droppedIndex + 1),
              ])
            : (categories = [
                  ...categories.slice(0, droppedIndex),
                  dragged,
                  ...categories.slice(droppedIndex),
              ]);

        this.setState({
            categories,
            dragged: null,
            rearranged: true,
        });
    }

    render() {
        let { categories, newCategory, editingCatName, rearranged } =
            this.state;
        return (
            <div className='CategoriesComponent'>
                <Filter></Filter>
                {!rearranged && (
                    <div className='addCategory'>
                        <div className='caption text info'>
                            اضافه کردن دسته بندی جدید
                        </div>
                        <form id='addCategoryForm'></form>
                        <div className='name'>
                            نام دسته بندی
                            <input
                            className={`!bg-red-200 px-1 rounded-lg`}
                                type='text'
                                name='name'
                                form='addCategoryForm'
                                defaultValue={newCategory.name}
                                onChange={(ev) => {
                                    editingCatName
                                        ? (newCategory.newName =
                                              ev.target.value)
                                        : (newCategory.name = ev.target.value);
                                    this.setState({ newCategory });
                                }}
                            />
                        </div>
                        <div className='img'>
                            <img
                                src={
                                    (newCategory &&
                                        newCategory.image &&
                                        newCategory.image.url) ||
                                    newCategory.image
                                }
                            />
                            <div
                                className='changeImage btn secondary'
                                onClick={(ev) => {
                                    this.imageInputRef.current.click();
                                }}
                            >
                                بارگذاری تصویر
                                <input
                                    ref={this.imageInputRef}
                                    type='file'
                                    accept='image/*'
                                    name='file'
                                    single='true'
                                    onChange={(ev) => {
                                        editingCatName &&
                                            (newCategory.newName =
                                                newCategory.name);
                                        const file = ev.target.files[0];
                                        newCategory.image = {
                                            url: URL.createObjectURL(file),
                                            file,
                                        };
                                        this.setState({
                                            newCategory,
                                            newCategory,
                                        });
                                    }}
                                />
                            </div>
                        </div>

                        <div className='actions'>
                            <button
                                className='add btn confirm'
                                onClick={this.save_category}
                            >
                                {editingCatName ? "ویرایش" : "اظافه کردن"} دسته
                                بندی
                                <i className='ri-add-line '></i>
                            </button>
                        </div>
                    </div>
                )}

                {rearranged && (
                    <div className='arrangment'>
                        <div
                            className='saveNewArrange btn confirm'
                            onClick={this.save_new_arrange}
                        >
                            ذخیره چینش جدید
                        </div>
                        <div
                            className='cancelNewArrange btn danger'
                            onClick={(ev) => {
                                this.setState({ rearranged: false });
                                this.componentDidMount();
                            }}
                        >
                            لغو چینش جدید
                        </div>
                    </div>
                )}
                <div className='categories'>
                    {categories &&
                        categories.length > 0 &&
                        categories.map((c) => {
                            return (
                                <CategoryRow
                                    category={c}
                                    key={c.name}
                                    toast={this.props.toast}
                                    delete={this.delete}
                                    edit={this.edit}
                                    onDrag={this.onDrag}
                                    onDrop={this.onDrop}
                                ></CategoryRow>
                            );
                        })}
                </div>
            </div>
        );
    }
}

export default Categories;
